/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import Filters from "../../Components/Reports/Filters";
import moment from "moment";
import styles from "../../Styles/dashboard.module.css";
import { useLocation } from "react-router-dom";
import { Grid, useMediaQuery } from "@mui/material";
import { urlEnum } from "../../Utils/UrlEnum";
import { getData } from "../../Services/getData";
import OrderReport from "../../Components/Reports/OrderReport";
import { dayPilotFormat } from "../../Utils/Config";
import { FiltersModel } from "../../Utils/Models";

export default function OrdersReports() {
  const location = useLocation();
  const phoneStyle = useMediaQuery("(max-width:800px)");
  const [ordersReports, setOrdersReports] = useState<any>([]);
  const [filters, setFilters] = useState<FiltersModel>({
    startDate: moment().subtract(1, "months"),
    endDate: moment(),
    user: null,
    order: null,
  });

  /**
   *
   */
  useEffect(() => {
    let search: any = decodeURIComponent(location.search);
    search = search.split(/[?&]+/);
    const newFilters: any = {
      startDate: moment().subtract(1, "months"),
      endDate: moment(),
      user: null,
      order: null,
    };
    search.forEach((value: any) => {
      if (value !== "") {
        const values = value.split("=");
        newFilters[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
        if (values[0] === "page") newFilters[values[0]] = +values[1] - 1;
        if (values[1] === "null") newFilters[values[0]] = null;
      }
    });
    setFilters({
      ...newFilters,
      startDate: moment(newFilters.startDate, dayPilotFormat),
      endDate: moment(newFilters.endDate, dayPilotFormat),
    });
    getOrderReports(newFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  /**
   *
   */
  function getOrderReports(newFilter: FiltersModel) {
    const url = `${urlEnum.ordersReports}/${newFilter.order}/${moment(
      newFilter.startDate
    ).format(dayPilotFormat)}/${moment(newFilter.endDate).format(
      dayPilotFormat
    )}`;
    getData(url).then((response) => {
      if (
        response &&
        response.data &&
        (response.data.status === 200 || response.data.status === 201)
      ) {
        setOrdersReports(response.data.result);
      }
    });
  }

  /**
   *
   */
  async function recalculateReports() {
    const response = await getData(urlEnum.ordersReports);
    if (
      response &&
      response.data &&
      (response.data.status === 200 || response.data.status === 201)
    ) {
      getOrderReports(filters);
    }
  }

  return (
    <div
      className={
        phoneStyle
          ? styles.mainContainerReportsMobile
          : styles.mainContainerReports
      }
    >
      <Filters
        filters={filters}
        recalculateReportsButton={true}
        recalculateReportsFunction={recalculateReports}
        order={{
          show: true,
          multiple: false,
          disableClearable: true,
        }}
      />
      <Grid
        container
        spacing={4}
        style={phoneStyle ? { marginBottom: 80 } : {}}
      >
        {ordersReports.map((report: any) => (
          <Grid
            item
            xs={12}
            md={12}
            lg={ordersReports.length === 1 ? 12 : 6}
            key={report._id}
          >
            <OrderReport orderReport={report} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
